import React from 'react';

import FilterOptionsColor from './FilterOptionsColor';

const FilterOptionsColorWheel = (props) => {
  // TODO: implement color wheel filter option, temp using fallback
  // https://techstyle-prod.atlassian.net/browse/FLCE-3052

  return <FilterOptionsColor {...props} />;
};

export default FilterOptionsColorWheel;
